import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("nav-item__link-2esvw6", {
  display: "flex",
  alignItems: "flex-end",
  lineHeight: 1,
  whiteSpace: "nowrap",
  flexShrink: 0,
  minWidth: "max-content",
  width: "max-content",
  overflow: "visible",
  wordBreak: "keep-all",
  hyphens: "none",
  flexWrap: "nowrap",
  "& *": {
    whiteSpace: "nowrap",
    wordBreak: "keep-all",
    flexWrap: "nowrap",
    display: "inline"
  }
});
const _staticStyles2 = _cssRef("nav-item__typography-20lq88", {
  color: "var(--system-grey-800)",
  height: "100%",
  display: "flex",
  alignItems: "center",
  position: "relative",
  transition: "color 0.2s",
  whiteSpace: "nowrap",
  flexShrink: 0,
  minWidth: "max-content",
  width: "max-content",
  overflow: "visible",
  textOverflow: "clip",
  wordBreak: "keep-all",
  lineHeight: 1,
  flexWrap: "nowrap",
  "& svg": {
    transition: "transform 0.3s"
  },
  "[data-state=\"open\"] &": {
    color: "var(--primary-orange-500)",
    "& svg": {
      transform: "rotate(180deg)"
    }
  },
  "[data-menu=\"item\"]:has([data-menu=\"trigger\"][data-state=\"open\"]) &": {
    color: "var(--primary-orange-500)"
  },
  "& *": {
    whiteSpace: "nowrap",
    wordBreak: "keep-all",
    flexWrap: "nowrap"
  }
});
import React from 'react';
import Link from '../../primitives/link';
import Typography from '../../primitives/typography';
import { colors } from '../../primitives/colors';
const styles = {
  link: _staticStyles,
  typography: _staticStyles2
};
const NavItem = ({
  to,
  className,
  children
}: React.PropsWithChildren<{
  to?: string;
  className?: string;
}>): JSX.Element => {
  let element;
  if (to) {
    element = <Link {..._mergeComponentProps({
      to: to,
      className: className,
      css: styles.link
    })}>
                {children}
            </Link>;
  } else {
    element = <div {..._mergeProps({
      className: className,
      css: styles.link
    })}>
                {children}
            </div>;
  }
  return <Typography {..._mergeComponentProps({
    fontSize: {
      dt: 'xl'
    },
    fontWeight: "regular",
    css: styles.typography
  })}>
            {element}
        </Typography>;
};
export default NavItem;